// extracted by mini-css-extract-plugin
export default {"toggleButton":"toggleButton_toggleButton__4ivdC","option1":"toggleButton_option1__P3dcW","option3":"toggleButton_option3__pTvyX","selected":"toggleButton_selected__s5wmZ"};